<template>
  <span class="clerk-logo"
    ><span class="clerk-logo__auto">Auto</span
    ><span class="clerk-logo__auction">Auction</span
    ><span class="clerk-logo__domain">.com</span
  ></span>
</template>

<script setup>
// The live-text autoauction.com wordmark in the console's top bar.
//
// It took a `theme` prop and painted itself white or near-black from it. That
// prop is gone: "Auto" now reads `{text.color}`, which already flips with the
// color scheme, so the wordmark follows light and dark with nothing passed in
// and nothing to keep in step. "Auction" stays the brand accent in both.
defineOptions({ name: 'ClerkLogo' });
</script>

<style scoped>
.clerk-logo {
  font-family: var(--p-clerk-logo-font-family);
  font-weight: var(--p-clerk-logo-font-weight);
  letter-spacing: var(--p-clerk-logo-letter-spacing);
  font-size: var(--p-clerk-logo-font-size);
  line-height: var(--p-clerk-logo-line-height);
  white-space: nowrap;
}

.clerk-logo__auto {
  color: var(--p-clerk-logo-auto-color);
}

.clerk-logo__auction {
  color: var(--p-clerk-logo-auction-color);
}

/* Set in em so the suffix keeps its proportion at whatever size the wordmark
   is rendered — this is the mark's construction, not a theme decision. */
.clerk-logo__domain {
  color: var(--p-clerk-logo-domain-color);
  font-size: 0.45em;
  margin-left: 0.05em;
}
</style>
